import {
  ADD_GENDER_FAIL,
  ADD_GENDER_SUCCESS,
  ADD_GENDER_REQUEST,
  DELETE_GENDER_REQUEST,
  DELETE_GENDER_SUCCESS,
  GETDETAIL_GENDER_REQUEST,
  GETDETAIL_GENDER_FAIL,
  GETDETAIL_GENDER_SUCCESS,
  UPDATE_GENDER_FAIL,
  UPDATE_GENDER_SUCCESS,
  UPDATE_GENDER_REQUEST,
  DELETE_GENDER_FAIL,
  GETALL_GENDER_FAIL,
  GETALL_GENDER_SUCCESS,
  GETALL_GENDER_REQUEST,
  CLEAR_GENDER_RECORD,
} from "../constant/GenderConstant";

const initialState = {
  loading: false,
  action: "Gender",
  result: [],
  singledata: [],
  success: false,
  message: "",
  error: "",
};

const GenderReducer = (state = initialState, action) => {
  switch (action.type) {
    case GETALL_GENDER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GETALL_GENDER_SUCCESS:
      return {
        ...state,
        loading: false,
        result: action.payload.data.list,
        message: action.message,
      };
    case GETALL_GENDER_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
        message: action.message,
      };
    case GETDETAIL_GENDER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GETDETAIL_GENDER_SUCCESS:
      return {
        ...state,
        loading: false,
        singledata: action.payload.data,
        message: action.message,
      };
    case GETDETAIL_GENDER_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
        message: action.message,
      };

    case ADD_GENDER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ADD_GENDER_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        result: state.result.filter((items) =>
          items.id === action.payload.id
            ? Object.assign({}, items, action.payload)
            : items
        ),
        message: action.message,
      };
    case ADD_GENDER_FAIL:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.error,
        message: action.message,
      };

    case UPDATE_GENDER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_GENDER_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        result: state.result.map((items) =>
          items.id === action.payload.id
            ? Object.assign({}, items, action.payload)
            : items
        ),
        message: action.payload,
      };
    case UPDATE_GENDER_FAIL:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.error,
        message: action.message,
      };
    case DELETE_GENDER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case DELETE_GENDER_SUCCESS:
      return {
        ...state,
        loading: false,
        result: state.result.filter((item) => item.id !== action.payload.id),
        message: action.message,
      };
    case DELETE_GENDER_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CLEAR_GENDER_RECORD:
      return {
        ...state,
        loading: false,
        result: [],
        singledata: [],
        message: action.message,
      };
    default:
      return state;
  }
};

export default GenderReducer;
